import React from 'react';
import { Box, Typography } from '@mui/material';

const styles = {
  container: {
    position: 'absolute',
    bottom: 16,
    left: 16,
    p: 0.5,
    zIndex: 1000,
    pointerEvents: 'none'
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    mb: 0.25
  },
  text: {
    fontSize: '10px',
    fontWeight: 400,
    color: '#333'
  }
};

const legendItems = [
  {
    type: 'node',
    label: 'Company',
    style: {
      width: 10,
      height: 10,
      backgroundColor: '#0E1944',
      borderRadius: '50%',
      opacity: 0.8,
      mr: 1
    }
  },
  {
    type: 'node',
    label: 'Person',
    style: {
      width: 10,
      height: 10,
      backgroundColor: '#4566EB',
      borderRadius: '50%',
      opacity: 0.8,
      mr: 1
    }
  },
  {
    type: 'node',
    label: 'Address',
    style: {
      width: 10,
      height: 10,
      backgroundColor: '#07A8FF',
      borderRadius: '50%',
      opacity: 0.8,
      mr: 1
    }
  },
  {
    type: 'edge',
    label: 'Low Confidence',
    style: {
      width: 16,
      height: 2,
      backgroundColor: '#B8C5F2',
      opacity: 0.8,
      mr: 1
    }
  },
  {
    type: 'edge',
    label: 'High Confidence',
    style: {
      width: 16,
      height: 2,
      backgroundColor: '#B2B8CF',
      opacity: 1,
      mr: 1
    }
  },
];


const Legend = () => {

  return (
    <Box sx={styles.container}>
      {legendItems.map((item, index) => (
        <Box
          key={item.label}
          sx={{
            ...styles.itemContainer,
            mb: index < legendItems.length - 1 ? 0.5 : 0
          }}
        >
          <Box sx={item.style} />
          <Typography variant="body2" sx={styles.text}>
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Legend;